export default __webpack_public_path__ + "static/media/main-nodrums.b36a5309.mp3";